<template>
  <div>
    <ZoomImage  style="z-index: 102;" :pose="pose">
      <markupFullscreen
      ref="markupFullscreen"
      :readonly="readonly"
      :detailPage="detailPage"
        v-on:fullscreen="toggleZoom"
        v-on:showMarkerDetails="showMarkerDetails"
        v-bind:blueprint="blueprint"        
      ></markupFullscreen>
    </ZoomImage>
  </div>
</template>

<script>
import posed from "vue-pose";
import markupFullscreen from "@/components/pages/Markers/MarkUpFullScreen";

const transition = {
  duration: 400,
  ease: [0.08, 0.69, 0.2, 0.99]
};

export default {
  name: "zoomPicture",
  props: {
    blueprint: Object,
    detailPage: Boolean,
    readonly: Boolean,
  },
  data: () => ({ isZoomed: false,
  poseComplete: false }),
  computed: {
    pose() {
      return this.isZoomed ? "zoomedIn" : "zoomedOut";
    },
    toggleZoom() {
      this.$emit('fullscreen',this.isZoomed)
      return this.isZoomed ? this.zoomOut : this.zoomIn;
    }
  },
  methods: {
    complete(){
      this.poseComplete = true;
    },
    showMarkerDetails(marker) {
      if(this.readonly){
         this.$router.push({
        name: "MarkerDetails",
        params: {
          id: marker.id,
          marker: marker,
          blueprint: this.blueprint,
        }
      });
      }
      else{
         this.$router.push({
        name: "EditMarkerDetails",
        params: {
          id: marker.id,
          marker: marker,
          blueprint: this.blueprint,
        }
      });
      }
     
    },
    zoomIn() {
      //window.addEventListener("scroll", this.zoomOut);
      this.$forceUpdate()
      this.isZoomed = true;
    },
    zoomOut() {
      //window.removeEventListener("scroll", this.zoomOut);
      this.isZoomed = false;
    }
  },
  components: {
    markupFullscreen,
    Frame: posed.div({
      zoomedOut: {
        applyAtEnd: { display: "none" },
        opacity: 0
      },
      zoomedIn: {
        applyAtStart: { display: "block" },
        opacity: 1
      }
    }),
    ZoomImage: posed.div({
      zoomedOut: {
        position: "static",
        width: "auto",
        height: "auto",
        transition,
        flip: true
      },
      zoomedIn: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition,
        flip: true,
        width: "auto",
        height: "auto"
      }
    })
  }
};
</script>

<style scoped>
.img {
  cursor: zoom-in;
  display: block;
  max-width: 100%;
  margin: auto;
  z-index: 2;
  object-fit: cover;
}

.img.zoomed {
  cursor: zoom-out;
}
.frame {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 1;
  background: white;
  transform: translateZ(0);
}
/* div {
  height: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/Markers/ZoomMarkup.vue